import { render } from "./DatasetSelection.vue?vue&type=template&id=4924704c"
import script from "./DatasetSelection.vue?vue&type=script&lang=js"
export * from "./DatasetSelection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__